import script from "./AddUserGroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserGroupForm.vue?vue&type=script&setup=true&lang=js"

import "./AddUserGroupForm.vue?vue&type=style&index=0&id=0a45fb64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a45fb64"]])

export default __exports__